export const validation = {
  maxTitleChar: 120,
  contentTitleMaxChar: 200,
  contentParagraphMaxChar: 2000,
  content: {
    min: 1,
    max: 4
  }
}
